import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input, Select } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { AddWithdrawRequestApi } from '../../../../../api/request/wallet/withdraw.js';
import { useResponsive } from '../../../../../hooks/useResponsive.js';


const CashWithdraw = ({ amount, resetAll, details, validateAmount }) => {
  const { isMobile } = useResponsive()
  const [form] = Form.useForm();
  const { userDetails } = useSelector(state => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMobile, setSelectedMobile] = useState(null);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      if (validateAmount) {
        toast.error(validateAmount);
        return;
      }
      if (!amount) {
        toast.error('Please enter withdrawal amount');
        return;
      }
      const params = {
        userId: userDetails?.id,
        amount: Number(amount),
        withdrawalMethod: 6,
        ...values
      };

      const { data } = await AddWithdrawRequestApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form?.resetFields();
        resetAll();
      }
    } catch (error) {
      if (error?.response?.data?.error?.message)
        toast.error(error?.response?.data?.error?.message);
    } finally {
      setIsLoading(false);
    }
  }

  const mobileOptions = details?.map(mobile => ({ label: mobile, value: mobile, }));

  const handleMobileChange = (mobile) => {
    form.setFieldsValue({ mobileNumber: mobile });
    setSelectedMobile(mobile);
  };

  useEffect(() => {
    if (details && details.length > 0) {
      form.setFieldsValue({ mobileNumber: details[0] });
      setSelectedMobile(details[0]);
    } else {
      form.resetFields();
    }
  }, [details]);

  return (
    <div>
      <Form form={form} layout="vertical" className='space-y-5' onFinish={handleSubmit}>
        <div className="grid sm:grid-cols-2 gap-5">

          {details?.length > 1 && (
            <Form.Item {...(!isMobile && { label: <span className="text-lg text-gray-500 font-medium">Select Mobile Number</span> })}>
              <Select value={selectedMobile} onChange={handleMobileChange} options={mobileOptions} />
            </Form.Item>
          )}

          <Form.Item
            name="mobileNumber"
            {...(!isMobile && { label: <span className="text-lg text-gray-500 font-medium">Mobile Number</span> })}
            rules={[{ required: true, message: 'Please enter mobile number' }]}
          >
            <Input placeholder="Mobile Number" size='large' type='number' className={isMobile ? 'py-3' : ''} />
          </Form.Item>
        </div>

        <Form.Item
          name='conditions'
          valuePropName="checked"
          rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
        >
          <Checkbox className='mt-4'>
            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
          </Checkbox>
        </Form.Item>

        <LoadableButton
          className='bg-primary-mobile sm:bg-primary text-sm text-white font-semibold rounded-lg px-12 py-4 sm:py-2 w-full sm:w-fit uppercase themeHover duration-500'
          type="submit"
          lable='Submit'
          isLoading={isLoading}
          loadingLable='Adding request...'
        />
      </Form>
    </div>
  )
}

export default CashWithdraw

